import {has, get} from 'lodash';
import {Response} from '@angular/http';
import {HttpStatus} from '../constants';
import {Injectable} from '@angular/core';
import {ErrorResponse} from './error.response.i';
import {ExceptionFactory} from './exception';

@Injectable()
export class CommonErrorResolver {

    resolve(error: any): ErrorResponse {
        if (this.isHTTPError(error)) {
            return this.resolveHTTPError(error);
        } else {
            throw ExceptionFactory.createSystemException('Internal system error!', error);
        }
    }

    /** The error as {status, code, message} without resolving it (no exception is thrown). */
    toErrorResponse(error: any): ErrorResponse {
        return this.isHTTPError(error)
            ? this.httpResponseToErrorResponse(error)
            : {status: 0, code: undefined, message: 'Internal system error!', messageArgs: undefined};
    }

    protected isHTTPError(error: any): boolean {
        return has(error, 'status');
    }

    protected resolveHTTPError(error: any): ErrorResponse {
        switch (error.status) {
            case HttpStatus.BAD_REQUEST:
                return this.resolveBadRequestErrors(this.httpResponseToErrorResponse(error));

            case HttpStatus.UNAUTHORIZED:
                return this.resolveAuthorizationErrors(this.httpResponseToErrorResponse(error));

            case HttpStatus.FORBIDDEN:
                return this.resolveForbiddenErrors(this.httpResponseToErrorResponse(error));

            case HttpStatus.NOT_FOUND:
                return this.resolveNotFoundError(error);

            case HttpStatus.INTERNAL_SERVER_ERROR:
                return this.resolveInternalServerError(this.httpResponseToErrorResponse(error));

            case HttpStatus.BAD_GATEWAY_ERROR:
                return this.resolveUnavailableError(error);

            default:
                return this.resolveUndefinedSystemError(this.httpResponseToErrorResponse(error));
        }
    }

    protected resolveBadRequestErrors(error: ErrorResponse): ErrorResponse {
        throw ExceptionFactory.createServerException(error.status, error.message, error.code)
    }

    protected resolveAuthorizationErrors(error: ErrorResponse): ErrorResponse {
        throw ExceptionFactory.createServerException(error.status, error.message)
    }

    protected resolveForbiddenErrors(error: ErrorResponse): ErrorResponse {
        throw ExceptionFactory.createServerException(error.status, error.message)
    }

    protected resolveInternalServerError(error: ErrorResponse): ErrorResponse {
        throw ExceptionFactory.createServerException(error.status, error.message)
    }

    protected resolveUndefinedSystemError(error: ErrorResponse): ErrorResponse {
        throw ExceptionFactory.createServerException(error.status, error.message)
    }

    protected resolveUnavailableError(error: any): ErrorResponse {
        throw ExceptionFactory.createUnavailableException(get(error, 'statusText', 'Unavailable exception!'));
    }

    protected resolveNotFoundError(error: any): ErrorResponse {
        throw ExceptionFactory.createUnavailableException(get(error, 'statusText', 'Not found error!'));
    }

    protected httpResponseToErrorResponse(error: any): ErrorResponse {
        let code = undefined,
            message = undefined,
            messageArgs = undefined,
            status = error.status;

        if (error instanceof Response) {
            try {
                const response: any = error.json();

                // Check if response is a plain string (backend returned a JSON string like "\"message\"")
                if (typeof response === 'string') {
                    message = response;
                } else {
                    code = get(response, 'code');
                    message = get(response, 'message');
                    messageArgs = get(response, 'messageArgs');
                }
            } catch (e) {
                // If JSON parsing fails, try to get text response
                try {
                    message = error.text();
                } catch (textError) {
                    message = 'Unknown server error';
                }
            }
        }

        return {status, code, message, messageArgs};
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/common.error.resolver.ts